export const APPLE_LINK = (trackingCode) => {
	const source = encodeURIComponent(trackingCode);
	return `https://itunes.apple.com/app/apple-store/id338701294?pt=296162&ct=${source}%20Score&mt=8`;
};

export const ANDROID_LINK = (trackingCode, finalString = "%26utm_medium%3Dweb") => {
	const source = encodeURIComponent(trackingCode);
	const final = encodeURIComponent(finalString);
	return `https://play.google.com/store/apps/details?id=com.okcupid.okcupid&referrer=utm_source%3D${source}${final}`;
};

export const APP_STORE_CAMPAIGNS = {
	"playFriendScorePromo": APPLE_LINK("Play%20Friend%20Score"),
	"okcupid.com/app": APPLE_LINK("okcupid.com"),
	"okcupid.com/mobile": APPLE_LINK("okcupid.com"),
	"mobile_redirect": APPLE_LINK("mobile_redirect"),
	"mobile_redirect_mandatory": APPLE_LINK("mobile_redirect_mandatory"),
	"mobile_redirect_optional": APPLE_LINK("mobile_redirect_optional"),
	"okcupid.com/logout": APPLE_LINK("okcupid.com%2Flogout"),
	"okcupid-email": APPLE_LINK("email"),
	"thewaywemet": APPLE_LINK("thewaywemet"),
	"themoth": APPLE_LINK("themoth"),
	"desktophome": APPLE_LINK("desktophome"),
	"footer_cta": APPLE_LINK("footer_cta"),
};

export const PLAY_STORE_CAMPAIGNS = {
	"okcupid.com/app": ANDROID_LINK("okcupid.com%252Fapp"),
	"okcupid.com/mobile": ANDROID_LINK("okcupid.com%252Fmobile"),
	"mobile_redirect": ANDROID_LINK("mobile_redirect"),
	"mobile_redirect_mandatory": ANDROID_LINK("mobile_redirect_mandatory"),
	"mobile_redirect_optional": ANDROID_LINK("mobile_redirect_optional"),
	"okcupid.com/logout": ANDROID_LINK("okcupid.com%252Flogout"),
	"okcupid-email": ANDROID_LINK("email", "%26utm_medium%3Demail%26anid%3Dadmob"),
	"thewaywemet": ANDROID_LINK("thewaywemet"),
	"themoth": ANDROID_LINK("themoth"),
	"desktophome": ANDROID_LINK("desktophome"),
	"footer_cta": ANDROID_LINK("footer_cta", "%26utm_medium%3Dweb"),
};



// WEBPACK FOOTER //
// ./src/shared/dictionaries/app_store_campaigns.js